(function () {  

    const tooltipContainer = document.querySelector('.tooltip-container');
    const tooltip = document.querySelector('.custom-tooltip');
    const button = document.querySelector('.button-with-tooltip');
    let isTooltipVisible = false;
  
    if (tooltip){
      let isTooltipVisible = false;
  
      function checkTooltipPosition() {
        const containerRect = tooltipContainer.getBoundingClientRect();
        const tooltipWidth = 300; // Our fixed tooltip width
        const tooltipHeight = tooltip.offsetHeight;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        
        // Reset classes
        tooltipContainer.classList.remove('tooltip-bottom', 'tooltip-right');
        
        // Check horizontal positioning first
        const tooltipLeft = containerRect.left + (containerRect.width / 2) - (tooltipWidth / 2);
        const tooltipRight = tooltipLeft + tooltipWidth;
        
        // If tooltip would be cut off on the left or right, position it to the right of button
        if (tooltipLeft < 10 || tooltipRight > viewportWidth - 10) {
          tooltipContainer.classList.add('tooltip-right');
          return; // When showing on right, we don't need to check vertical position
        }
        
        // Check vertical positioning (only for top/bottom positioning)
        if (containerRect.top - tooltipHeight - 8 < 0) {
          tooltipContainer.classList.add('tooltip-bottom');
        }
      }
    
      // Check position on hover (desktop)
      tooltipContainer.addEventListener('mouseenter', checkTooltipPosition);
    
      // Mobile touch support with double-tap navigation
      button.addEventListener('touchstart', function(e) {
        e.preventDefault();
        
        if (!isTooltipVisible) {
          // First tap: show tooltip
          checkTooltipPosition();
          tooltipContainer.classList.add('active');
          isTooltipVisible = true;
          
          // Hide tooltip after 5 seconds if no second tap
          setTimeout(() => {
            if (isTooltipVisible) {
              tooltipContainer.classList.remove('active');
              isTooltipVisible = false;
            }
          }, 5000);
        } else {
          // Second tap: navigate (let the default button behavior happen)
          tooltipContainer.classList.remove('active');
          isTooltipVisible = false;
          
          // If button has a data-href or onclick, trigger it
          const href = button.getAttribute('data-href');
          const onclick = button.getAttribute('onclick');
          
          if (href) {
            window.location.href = href;
          } else if (onclick) {
            eval(onclick);
          } else {
            // Trigger any click event handlers
            button.click();
          }
        }
      });
    
      // Alternative: Use click event for second tap (cleaner approach)
      button.addEventListener('click', function(e) {
        // Only prevent default on mobile if tooltip is not visible
        if (isMobile()) {
          if (!isTooltipVisible) {
            e.preventDefault();
            return false;
          }
        }
        window.location.href = button.getAttribute('data-href');
      });
    
      // Hide tooltip when touching outside
      document.addEventListener('touchstart', function(e) {
        if (!tooltipContainer.contains(e.target)) {
          tooltipContainer.classList.remove('active');
          isTooltipVisible = false;
        }
      });
    
      // Reset tooltip state when page becomes visible again
      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible') {
          tooltipContainer.classList.remove('active');
          isTooltipVisible = false;
        }
      });
    }
  
    function isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
  
    const buttonScrollTo = document.querySelector('.button-scrollto');
    if(buttonScrollTo){
        buttonScrollTo.addEventListener('click', function(e) {
          e.preventDefault();
          var scrollTo = buttonScrollTo.parentElement.parentElement.offsetHeight;
          window.scrollTo({top: scrollTo, behavior: 'smooth'});
        });
    }
  
    
    
    const playVideo = (slider) => {
      if (!slider.tagName) {
        if (slider.slides[slider.previousIndex]) {
          const videoPrev = slider.slides[slider.previousIndex].querySelector('.media-slideshow__video video');
          if (videoPrev) {
            videoPrev.pause();
          }
    
          const videoUrlPrev = slider.slides[slider.previousIndex].querySelector('.media-slideshow__video iframe');
          if (videoUrlPrev) {
            if (videoUrlPrev.classList.contains('js-youtube')) {
              videoUrlPrev.contentWindow.postMessage(
                '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
                "*",
              );
              videoUrlPrev.classList.add('video-pause');
              videoUrlPrev.classList.remove('video-play');
            }
            else if (videoUrlPrev.classList.contains('js-vimeo')) {
              videoUrlPrev.contentWindow.postMessage('{"method":"pause"}', "*");
              videoUrlPrev.classList.add('video-pause');
              videoUrlPrev.classList.remove('video-play');
            }
          }
        }
    
        if (slider.slides[slider.activeIndex]) {
          const videoActive = slider.slides[slider.activeIndex].querySelector('.media-slideshow__video video');
          if (videoActive) {
            const button = slider.slides[slider.activeIndex].querySelector('.js-play-video');
    
            if (videoActive.parentElement.classList.contains('autoplay')) {
              videoActive.autoplay = true;
              if (button) {
                button.classList.remove('active');
              }
            }
    
            if (videoActive.autoplay && videoActive.paused) {
              videoActive.play();
            }
    
            if (!videoActive.autoplay && button) {
              button.classList.remove('active');
            }
          }
    
          const videoUrlActive = slider.slides[slider.activeIndex].querySelector('.media-slideshow__video iframe');
          if (videoUrlActive) {
            const button = slider.slides[slider.activeIndex].querySelector('.js-play-video');
            if (videoUrlActive.parentElement.classList.contains('autoplay')) {
              if (videoUrlActive.classList.contains('js-youtube')) {
                videoUrlActive.contentWindow.postMessage(
                  '{"event":"command","func":"' + "playVideo" + '","args":""}',
                  "*",
                );
                if (videoUrlActive.classList.contains('video-muted')) {
                  videoUrlActive.contentWindow.postMessage(
                    '{"event":"command","func":"' + "mute" + '","args":""}',
                    "*",
                  );
                }
                else {
                  videoUrlActive.contentWindow.postMessage(
                    '{"event":"command","func":"' + "unMute" + '","args":""}',
                    "*",
                  );
                }
                videoUrlActive.classList.add('video-play');
                videoUrlActive.classList.remove('video-pause');
              }
              else if (videoUrlActive.classList.contains('js-vimeo')) {
                videoUrlActive.contentWindow.postMessage('{"method":"play"}', "*");
                if (videoUrlActive.classList.contains('video-muted')) {
                  videoUrlActive.contentWindow.postMessage('{"method":"setVolume", "value":0}', '*');
                }
                else {
                  videoUrlActive.contentWindow.postMessage('{"method":"setVolume", "value":1}', '*');
                }
                videoUrlActive.classList.add('video-play');
                videoUrlActive.classList.remove('video-pause');
              }
              if (button) {
                button.classList.remove('active');
              }
            }
    
            if (videoUrlActive.parentElement.classList.contains('autoplay') && videoUrlActive.classList.contains('video-pause')) {
              if (videoUrlActive.classList.contains('js-youtube')) {
                videoUrlActive.contentWindow.postMessage(
                  '{"event":"command","func":"' + "playVideo" + '","args":""}',
                  "*",
                );
                if (videoUrlActive.classList.contains('video-muted')) {
                  videoUrlActive.contentWindow.postMessage(
                    '{"event":"command","func":"' + "mute" + '","args":""}',
                    "*",
                  );
                }
                else {
                  videoUrlActive.contentWindow.postMessage(
                    '{"event":"command","func":"' + "unMute" + '","args":""}',
                    "*",
                  );
                }
                videoUrlActive.classList.add('video-play');
                videoUrlActive.classList.remove('video-pause');
              }
              else if (videoUrlActive.classList.contains('js-vimeo')) {
                videoUrlActive.contentWindow.postMessage('{"method":"play"}', "*");
                if (videoUrlActive.classList.contains('video-muted')) {
                  videoUrlActive.contentWindow.postMessage('{"method":"setVolume", "value":0}', '*');
                }
                else {
                  videoUrlActive.contentWindow.postMessage('{"method":"setVolume", "value":1}', '*');
                }
                videoUrlActive.classList.add('video-play');
                videoUrlActive.classList.remove('video-pause');
              }
            }
    
            if (!videoUrlActive.parentElement.classList.contains('autoplay') && button) {
              button.classList.remove('active');
            }
          }
        }
      }
      else {
        const video = slider.querySelector('.media-slideshow__video video');
          if (video) {
            const button = slider.querySelector('.js-play-video');
    
            if (video.parentElement.classList.contains('autoplay')) {
              video.autoplay = true;
              if (button) {
                button.classList.remove('active');
              }
            }
    
            if (video.autoplay && video.paused) {
              video.play();
            }
    
            if (!video.autoplay && button) {
              button.classList.remove('active');
            }
          }
    
          const videoUrl = slider.querySelector('.media-slideshow__video iframe');
          if (videoUrl) {
            const button = slider.querySelector('.js-play-video');
            if (videoUrl.parentElement.classList.contains('autoplay')) {
              if (videoUrl.classList.contains('js-youtube')) {
                videoUrl.contentWindow.postMessage(
                  '{"event":"command","func":"' + "playVideo" + '","args":""}',
                  "*",
                );
                if (videoUrl.classList.contains('video-muted')) {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "mute" + '","args":""}',
                    "*",
                  );
                }
                else {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "unMute" + '","args":""}',
                    "*",
                  );
                }
                videoUrl.classList.add('video-play');
                videoUrl.classList.remove('video-pause');
              }
              else if (videoUrl.classList.contains('js-vimeo')) {
                videoUrl.contentWindow.postMessage('{"method":"play"}', "*");
                if (videoUrl.classList.contains('video-muted')) {
                  videoUrl.contentWindow.postMessage('{"method":"setVolume", "value":0}', '*');
                }
                else {
                  videoUrl.contentWindow.postMessage('{"method":"setVolume", "value":1}', '*');
                }
                videoUrl.classList.add('video-play');
                videoUrl.classList.remove('video-pause');
              }
              if (button) {
                button.classList.remove('active');
              }
            }
    
            if (videoUrl.parentElement.classList.contains('autoplay') && videoUrl.classList.contains('video-pause')) {
              if (videoUrl.classList.contains('js-youtube')) {
                videoUrl.contentWindow.postMessage(
                  '{"event":"command","func":"' + "playVideo" + '","args":""}',
                  "*",
                );
                if (videoUrl.classList.contains('video-muted')) {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "mute" + '","args":""}',
                    "*",
                  );
                }
                else {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "unMute" + '","args":""}',
                    "*",
                  );
                }
                videoUrl.classList.add('video-play');
                videoUrl.classList.remove('video-pause');
              }
              else if (videoUrl.classList.contains('js-vimeo')) {
                videoUrl.contentWindow.postMessage('{"method":"play"}', "*");
                if (videoUrl.classList.contains('video-muted')) {
                  videoUrl.contentWindow.postMessage('{"method":"setVolume", "value":0}', '*');
                }
                else {
                  videoUrl.contentWindow.postMessage('{"method":"setVolume", "value":1}', '*');
                }
                videoUrl.classList.add('video-play');
                videoUrl.classList.remove('video-pause');
              }
            }
    
            if (!videoUrl.parentElement.classList.contains('autoplay') && button) {
              button.classList.remove('active');
            }
          }
      }
    }
  
    const stopVideo = (slider) => {
      if (slider.slides[slider.activeIndex]) {
        const videoActive = slider.slides[slider.activeIndex].querySelector('.media-slideshow__video video');
        if (videoActive) {
          videoActive.pause();
        }
  
        const videoUrlActive = slider.slides[slider.activeIndex].querySelector('.media-slideshow__video iframe');
        if (videoUrlActive) {
          if (videoUrlActive.classList.contains('js-youtube')) {
            videoUrlActive.contentWindow.postMessage(
              '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
              "*",
            );
            videoUrlActive.classList.add('video-pause');
            videoUrlActive.classList.remove('video-play');
          }
          else if (videoUrlActive.classList.contains('js-vimeo')) {
            videoUrlActive.contentWindow.postMessage('{"method":"pause"}', "*");
            videoUrlActive.classList.add('video-pause');
            videoUrlActive.classList.remove('video-play');
          }
        }
      }
    }
  
    const controlsVideo = () => {
      const buttonsPlay = document.querySelectorAll('.js-play-video');
      const buttonsSound = document.querySelectorAll('.js-sound-video');
  
      buttonsPlay.forEach(button => {
        button.onclick = () => {
          if (button.previousElementSibling.classList.contains('media-slideshow__video')) {
            const video = button.previousElementSibling.querySelector('video');
            if (video) {
              if (video.paused) {
                setTimeout(() => {
                  video.play();
                }, 10);
              }
              else {
                setTimeout(() => {
                  video.pause();
                }, 10);
              }
              button.classList.toggle('active');
            }
  
            const videoUrl = button.previousElementSibling.querySelector('iframe');
            if (videoUrl) {
              if (videoUrl.classList.contains('video-pause')) {
                if (videoUrl.classList.contains('js-youtube')) {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "playVideo" + '","args":""}',
                    "*",
                  );
                  if (videoUrl.classList.contains('video-muted')) {
                    videoUrl.contentWindow.postMessage(
                      '{"event":"command","func":"' + "mute" + '","args":""}',
                      "*",
                    );
                  }
                  else {
                    videoUrl.contentWindow.postMessage(
                      '{"event":"command","func":"' + "unMute" + '","args":""}',
                      "*",
                    );
                  }
                  videoUrl.classList.add('video-play');
                  videoUrl.classList.remove('video-pause');
                }
                else if (videoUrl.classList.contains('js-vimeo')) {
                  videoUrl.contentWindow.postMessage('{"method":"play"}', "*");
                  if (videoUrl.classList.contains('video-muted')) {
                    videoUrl.contentWindow.postMessage('{"method":"setVolume", "value":0}', '*');
                  }
                  else {
                    videoUrl.contentWindow.postMessage('{"method":"setVolume", "value":1}', '*');
                  }
                  videoUrl.classList.add('video-play');
                  videoUrl.classList.remove('video-pause');
                }
              }
              else {
                if (videoUrl.classList.contains('js-youtube')) {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
                    "*",
                  );
                  videoUrl.classList.add('video-pause');
                  videoUrl.classList.remove('video-play');
                }
                else if (videoUrl.classList.contains('js-vimeo')) {
                  videoUrl.contentWindow.postMessage('{"method":"pause"}', "*");
                  videoUrl.classList.add('video-pause');
                  videoUrl.classList.remove('video-play');
                }
              }
              button.classList.toggle('active');
            }
          }
        }
      });
  
      buttonsSound.forEach(button => {
        button.onclick = () => {
          if (button.previousElementSibling.classList.contains('media-slideshow__video') || button.previousElementSibling.previousElementSibling.classList.contains('media-slideshow__video')) {
            const video = button.previousElementSibling.querySelector('video') || button.previousElementSibling.previousElementSibling.querySelector('video');
            if (video) {
              if (video.muted) {
                setTimeout(() => {
                  video.muted = false;
                }, 10);
              }
              else {
                setTimeout(() => {
                  video.muted = true;
                }, 10);
              }
              button.classList.toggle('active');
            }
  
            const videoUrl = button.previousElementSibling.querySelector('iframe') || button.previousElementSibling.previousElementSibling.querySelector('iframe');
            if (videoUrl) {
              if (videoUrl.classList.contains('video-muted')) {
                if (videoUrl.classList.contains('js-youtube')) {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "unMute" + '","args":""}',
                    "*",
                  );
                  videoUrl.classList.remove('video-muted');
                }
                else if (videoUrl.classList.contains('js-vimeo')) {
                  videoUrl.contentWindow.postMessage('{"method":"setVolume", "value":1}', '*');
                  videoUrl.classList.remove('video-muted');
                }
              }
              else {
                if (videoUrl.classList.contains('js-youtube')) {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "mute" + '","args":""}',
                    "*",
                  );
                  videoUrl.classList.add('video-muted');
                }
                else if (videoUrl.classList.contains('js-vimeo')) {
                  videoUrl.contentWindow.postMessage('{"method":"setVolume", "value":0}', '*');
                  videoUrl.classList.add('video-muted');
                }
              }
              button.classList.toggle('active');
            }
          }
        }
      })
    }
  
    const initSliders = () => {
      const sections = document.querySelectorAll('.media-slideshow-section');
  
      sections.forEach(section => {
        const mediaSliders = section.querySelectorAll('.media-slideshow__slider:not(.swiper-initialized)');
        const pagination = section.querySelector('.media-slideshow__wrapper .swiper-pagination');
  
        if (mediaSliders.length > 0) {
          const duration = Number(mediaSliders[0].getAttribute('data-duration'));
          const nextBtn = section.querySelector('.swiper-button-next');
          const prevBtn = section.querySelector('.swiper-button-prev');

          const swiperInstances = [];
          let isSyncing = false;

          const syncFrom = (sourceIdx, activeIndex) => {
            // Prevent feedback loops while still allowing followers to run playVideo in their handlers
            if (isSyncing) return;
            isSyncing = true;

            const total = swiperInstances.length;
            for (let step = 1; step < total; step++) {
              const j = (sourceIdx + step) % total; // cascade to the right and wrap
              const target = swiperInstances[j];
              if (target && target.slides[activeIndex]) {
                setTimeout(() => {
                  target.slideTo(activeIndex);
                }, step * 300);
              }
            }
            // Release sync flag after the last delayed transition is scheduled
            setTimeout(() => { isSyncing = false; }, (swiperInstances.length) * 320);
          };

          mediaSliders.forEach((sliderEl, index) => {
            const baseOptions = {
              slidesPerView: 'auto',
              allowTouchMove: true,
              speed: 1500,
              on: {
                init() {
                  swiperInstances[index] = this;
                  calculateSlideNavigationMediaSlider($(this.el).parent());
                },
                slideChange() {
                  // Reposition pagination/navigation container relative to current slide
                  calculateSlideNavigationMediaSlider($(this.el).parent());

                  // Sync others with staggered delays starting from the next slider to the right
                  syncFrom(index, this.activeIndex);

                  // Ensure media on this slide is handled
                  playVideo(this);
                },
              },
            };

            if (index === 0) {
              new Swiper(sliderEl, {
                ...baseOptions,
                pagination: {
                  el: pagination,
                  type: 'bullets',
                  clickable: true,
                  renderBullet: function(index, className) {
                    return '<span class="' + className + '"><svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><circle class="circle" style="animation-duration: ' + duration + 's" cx="8" cy="8" r="7" stroke="currentColor"/></svg></span>';
                  }
                },
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
              });
            } else {
              new Swiper(sliderEl, {
                ...baseOptions,
                grabCursor: true,
              });
            }
          });

          // Enable double-click / double-tap to follow links only on the 2nd and 3rd sliders (split layout side columns)
          const wrapperSplit = section.querySelector('.media-slideshow__wrapper--split');
          if (wrapperSplit) {
            const sideSliders = wrapperSplit.querySelectorAll('.media-slideshow__slider:nth-child(2), .media-slideshow__slider:nth-child(3)');
            sideSliders.forEach(side => {
              const links = side.querySelectorAll('a[href]:not([data-double-armed])');
              links.forEach(link => {
                link.setAttribute('data-double-armed', 'true');
                let last = 0;
                let resetTimer;
                let suppressNext = false;

                const handler = (e) => {
                  // Ignore clicks that come from a drag gesture
                  const container = link.closest('.swiper');
                  if (container && container.swiper && container.swiper.allowClick === false) {
                    e.preventDefault();
                    return;
                  }

                  if (suppressNext) {
                    e.preventDefault();
                    return;
                  }

                  const now = Date.now();
                  if (now - last < 500) {
                    // Double interaction – allow navigation. On touch, navigate manually and suppress the follow-up click
                    last = 0;
                    clearTimeout(resetTimer);
                    if (e.type === 'touchend') {
                      e.preventDefault();
                      const href = link.getAttribute('href');
                      if (href && href !== '#') {
                        suppressNext = true;
                        setTimeout(() => { suppressNext = false; }, 400);
                        window.location.href = href;
                      }
                    }
                    // For click, do nothing – default navigation proceeds
                  } else {
                    // First interaction – block navigation and wait for second tap/click
                    e.preventDefault();
                    last = now;
                    clearTimeout(resetTimer);
                    resetTimer = setTimeout(() => { last = 0; }, 600);
                  }
                };

                link.addEventListener('click', handler, { passive: false });
                link.addEventListener('touchend', handler, { passive: false });
              });
            });
          }
        }
      })
    }
  
    const calculateSlideNavigationMediaSlider = (handlerEl) => 
    {
      if(handlerEl.parents(".split_navigation_handler").length > 0)
      {
        if($(window).width() >= 990)
        {
          setTimeout(() => {
            var elContent = $(handlerEl).find(".swiper-slide-active .media-slideshow__content-wrapper")
            var elPagination = $(handlerEl).find(".media-slideshow__bottom");
            var paddingTop = parseInt($(handlerEl).parent().css("padding-top"));
            paddingTop = isNaN(paddingTop) ? 0 : paddingTop;
            
            if(elContent.length > 0 && elPagination.length > 0)
            {
              var h = paddingTop + elContent.height() + ((elContent.parent().outerHeight() - elContent.height()) / 2) + 20;  
              elPagination.css("top", h + "px");
              elPagination.css("bottom", "initial");
              elPagination.css("transition", "top 200ms ease-in-out");
            }
          },200);
        }
        else{
          setTimeout(() => {
            var elContent = $(handlerEl).find(".swiper-slide-active .media-slideshow__content-wrapper")
            var elPagination = $(handlerEl).find(".media-slideshow__bottom");
            if(elContent.length > 0 && elPagination.length > 0)
            {
              var h = elContent.height() + ((elContent.parent().outerHeight() - elContent.height()) / 2);  
              elPagination.css("top", h + "px");
              elPagination.css("bottom", "initial");
              elPagination.css("transition", "top 200ms ease-in-out");
            }
          },200);
        }
      }
    }
    
    const initSlidersMobile = () => {
      const sections = document.querySelectorAll('.media-slideshow-section');
  
      sections.forEach(section => {
        const mediaSlider = section.querySelector('.media-slideshow__slider_mobile:not(.swiper-initialized)');
        const pagination = section.querySelector('.media-slideshow__wrapper_mobile .swiper-pagination');
        
        if (mediaSlider) {
          const duration = Number(mediaSlider.getAttribute('data-duration'));
        
          const mediaSliderSwiper = new Swiper(mediaSlider, {
            slidesPerView: 1,
            speed: 700,
            allowTouchMove: true,
            watchSlidesProgress: true,
            focusableElements: 'input, select, option, textarea, label',
            pagination: {
              el: pagination,
              type: 'bullets',
              clickable: true,
              renderBullet: function(index, className) {
                return '<span class="' + className + '"><svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><circle class="circle" style="animation-duration: ' + duration + 's" cx="8" cy="8" r="7" stroke="currentColor"/></svg></span>';
              }
            }
          })
          
          mediaSliderSwiper.on('slideChange', function() {
            playVideo(mediaSliderSwiper);
          });
  
          //playVideo(mediaSliderSwiper);
        }
      })
    }
  
    const destroySlidersDesktop = () => {
          const mediaSliders = document.querySelectorAll('.media-slideshow__slider');
  
          mediaSliders.forEach((slider) => {
              if (slider.swiper && !slider.classList.contains('media-slideshow__slider_full') && !slider.classList.contains('media-slideshow__slider_split')) {
          stopVideo(slider.swiper);
          slider.swiper.destroy();
        }
          });
      };
  
    const destroySlidersMobile = () => {
          const mediaSliders = document.querySelectorAll('.media-slideshow__slider_mobile');
  
          mediaSliders.forEach((slider) => {
              if (slider.swiper) {
          stopVideo(slider.swiper);
          slider.swiper.destroy();
        }
          });
      };
  
    const initSection = () => {
      const sections = document.querySelectorAll('.media-slideshow-section');
  
      sections.forEach(section => {
        const sectionResizeObserver = new ResizeObserver((entries) => {
          const [entry] = entries;
          let mediaSliders = entry.target.querySelectorAll('.media-slideshow__slider');
    
          if (document.documentElement.clientWidth < 750 && !mediaSliders[0].classList.contains('media-slideshow__slider_full') && !mediaSliders[0].classList.contains('media-slideshow__slider_split')) {
            mediaSliders = entry.target.querySelectorAll('.media-slideshow__slider_mobile');
            destroySlidersDesktop();
            initSlidersMobile();
            
            mediaSliders.forEach((slider) => {
              if (slider.swiper)
                playVideo(slider.swiper);
              else
                playVideo(slider);
            });
          }
          else {
            mediaSliders = entry.target.querySelectorAll('.media-slideshow__slider');
            pagination = entry.target.querySelector('.media-slideshow__wrapper .swiper-pagination');
            if (!mediaSliders[0].classList.contains('media-slideshow__slider_full') && !mediaSliders[0].classList.contains('media-slideshow__slider_split')) {
              destroySlidersMobile();
            }
            initSliders();
    
            if (mediaSliders) {
              mediaSliders.forEach((slider) => {
                if (slider.swiper)
                  playVideo(slider.swiper);
                else
                  playVideo(slider);
              });
            }
          }
        });
    
        const sectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              let mediaSliders = entry.target.querySelectorAll('.media-slideshow__slider');
              if (document.documentElement.clientWidth < 750 && entry.target.querySelectorAll('.media-slideshow__slider_mobile').length > 0) {
                mediaSliders = entry.target.querySelectorAll('.media-slideshow__slider_mobile');
              }
    
              if (entry.isIntersecting) {
                mediaSliders.forEach((slider) => {
                  if (slider.swiper)
                    playVideo(slider.swiper);
                  else
                    playVideo(slider);
                });
              }
              else {
                mediaSliders.forEach((slider) => {
                  if (slider.swiper)
                    stopVideo(slider.swiper);
                })
              }
            });
          },
        );
  
        sectionResizeObserver.observe(section);
        sectionObserver.observe(section);
      });
    }
  
    setTimeout(() => {
      initSection();
      controlsVideo();
    }, 100);
  
    document.addEventListener("shopify:section:load", function () {
      initSection();
      controlsVideo();
    })
  
    window.addEventListener("focus", (event) => {
      const sections = document.querySelectorAll('.media-slideshow-section');
      sections.forEach(section => {
        let mediaSliders = section.querySelectorAll('.media-slideshow__slider');
        if (document.documentElement.clientWidth < 750 && section.querySelectorAll('.media-slideshow__slider_mobile').length > 0) {
          mediaSliders = section.querySelectorAll('.media-slideshow__slider_mobile');
        }
  
        mediaSliders.forEach(slider => {
          if (slider.swiper)
            playVideo(slider.swiper);
          else
            playVideo(slider);  
        });
      })
    })
  
    window.addEventListener("blur", (event) => {
      const sections = document.querySelectorAll('.media-slideshow-section');
      sections.forEach(section => {
        let mediaSliders = section.querySelectorAll('.media-slideshow__slider');
        if (document.documentElement.clientWidth < 750 && section.querySelectorAll('.media-slideshow__slider_mobile').length > 0) {
          mediaSliders = section.querySelectorAll('.media-slideshow__slider_mobile');
        }
  
        mediaSliders.forEach(slider => {
          if (slider.swiper) {
            stopVideo(slider.swiper);
          }
        });
      })
    })
  
  
      
  })()